import { useCallback, useEffect, useState } from "react";
import About from "../components/About";
import Services from "../components/Services";
import Contact from "../components/Contact";
import Header from "../components/Header";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

function Main() {
  const [ready, setReady] = useState(false);

  const handleReady = useCallback(() => {
    setReady(true);
  }, []);

  useEffect(() => {
    if (ready) {
      document.body.classList.remove("page-loading");
    } else {
      document.body.classList.add("page-loading");
    }

    return () => {
      document.body.classList.remove("page-loading");
    };
  }, [ready]);

  return (
    <div className={`page-shell${ready ? " is-ready" : ""}`}>
      <Navbar />
      <Header onReady={handleReady} />
      <main>
        <Services />
        <About />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
export default Main;
